import { ServiceBase } from '../../../core/services/ServiceBase'
import AlertProxy from './AlertProxy'

class AlertService extends ServiceBase {
  getAlertHighlight(params) {
    return this.getData(() => AlertProxy.getAlertHighlight(params))
  }
  getAlertList(params) {
    return this.getData(() => AlertProxy.getAlertList(params))
  }
  searchCompany(params) {
    return this.getData(() => AlertProxy.searchCompany(params))
  }
  searchIndustry(params) {
    return this.getData(() => AlertProxy.searchIndustry(params))
  }
  deleteAlert(params) {
    return this.getData(() => AlertProxy.deleteAlert(params))
  }
  markAsReadAlert(params) {
    return this.getData(() => AlertProxy.markAsReadAlert(params))
  }
  markAsUnreadAlert(params) {
    return this.getData(() => AlertProxy.markAsUnreadAlert(params))
  }
  updateAlertSettings(params) {
    return this.getData(() => AlertProxy.updateAlertSettings(params), true)
  }
  updateProfileSendEmail(params) {
    return this.getData(() => AlertProxy.updateProfileSendEmail(params), true)
  }
  deleteAlertProfile(params) {
    return this.getData(() => AlertProxy.deleteAlertProfile(params), true)
  }
  getPortfolios(params) {
    return this.getData(() => AlertProxy.getPortfolios(params))
  }
  getAlertDetails(params) {
    return this.getData(() => AlertProxy.getAlertDetails(params))
  }
  getScoreRangesCreditRisk(params) {
    return this.applyMemoryCache(
      'alerts/getScoreRangesCreditRisk',
      params,
    )(() => AlertProxy.getScoreRangesCreditRisk(params))
  }
  getScoreRangesPerformance(params) {
    return this.applyMemoryCache(
      'alerts/getScoreRangesPerformance',
      params,
    )(() => AlertProxy.getScoreRangesPerformance(params))
  }
  getCompanyInfo(params) {
    return this.applyMemoryCache(
      'alerts/getCompanyInfo',
      params,
    )(() => AlertProxy.getCompanyInfo(params))
  }
  getAlertCriteriaDynamic(params) {
    return this.getData(() => AlertProxy.getAlertCriteriaDynamic(params))
  }
}

export default new AlertService()
